import Dashboard from "../../views/dashboard/Dashboard.vue";

const informationentrymanagement = {
  path: "/informationmanagement",
  name: "informationmanagement",
  redirect: "informationentry",
  component: Dashboard,
  meta: {
    title: "信息管理",
    icon: "el-icon-s-release",
    role: false
  },
  children: [
    {
      path: "/informationentry",
      name: "informationentry",
      component: () =>
        import("../../components/informationmanagement/informationentry.vue"),
      meta: {
        title: "添加住户",
        icon: "el-icon-s-claim",
        role: false
      }
    },
    {
      path: "/passthough",
      name: "passthough",
      component: () =>
        import("../../components/informationmanagement/passthough.vue"),
      meta: {
        title: "通行记录",
        icon: "el-icon-video-camera-solid",
        role: false
      }
    },
    {
      path: "/abnormalrecord",
      name: "abnormalrecord",
      component: () =>
        import("../../components/informationmanagement/abnormalrecord.vue"),
      meta: {
        title: "注册异常",
        icon: "el-icon-warning",
        role: false
      }
    },
    {
      path: "/visitorregister",
      name: "visitorregister",
      component: () =>
        import("../../components/informationmanagement/visitorregister.vue"),
      meta: {
        title: "访客登记",
        icon: "el-icon-s-claim",
        role: false
      }
    },
    {
      path: "/visitorRecords",
      name: "visitorRecords",
      component: () =>
        import("../../components/informationmanagement/visitorRecords.vue"),
      meta: {
        title: "访客记录",
        icon: "el-icon-tickets",
        role: false
      }
    },
    {
      path: "/addUserIcCard",
      name: "addUserIcCard",
      component: () =>
        import("../../components/informationmanagement/addUserIcCard.vue"),
      meta: {
        title: "添加IC卡",
        icon: "el-icon-plus",
        role: false
      }
    }
  ]
};

export default informationentrymanagement;
